import request from './index';

export function detail(id) {
  return request.get('officialPageObject/getDetail', {
    params: {
      id,
    },
  });
}

